import React from "react";
import { IconCheck, IconX } from "@tabler/icons-react";
import styles from "./FormMessage.module.css";

const SUCCESS_CONFIG = {
  primaryText: "Thank You for filling up the form!",
  secondaryText: "Our experts will get in touch with you soon.",
  icon: IconCheck,
  containerClass: styles.successContainer,
  primaryClass: styles.primarySuccess,
  iconWrapperClass: styles.iconSuccess,
};

const ERROR_CONFIG = {
  primaryText: "Something went wrong.",
  secondaryText: "Please try again later or contact support.",
  icon: IconX,
  containerClass: styles.errorContainer,
  primaryClass: styles.primaryError,
  iconWrapperClass: styles.iconError,
};

export default function FormMessage({ type = "success", primaryText, secondaryText }) {
  const config = type === "error" ? ERROR_CONFIG : SUCCESS_CONFIG;
  const Icon = config.icon;

  return (
    <div className={`${styles.container} ${config.containerClass}`}>
      <div className={`${styles.iconWrapper} ${config.iconWrapperClass}`}>
        <Icon size={80} strokeWidth={2.5} color="#fff" />
      </div>
      <h2 className={`${styles.primary} ${config.primaryClass}`}>{primaryText ?? config.primaryText}</h2>
      <p className={styles.secondary}>{secondaryText ?? config.secondaryText}</p>
    </div>
  );
}
